import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../../shared/tabs.component';
import AgGrid from '../../shared/agGrid/agGrid.component';
import {
  allProvisionsPropTypes,
  provisionsProcessedSuccessfullyPropTypes,
  provisionsTrialBalancesNotReceivedPropTypes,
  provisionsTrialBalancesWithErrorsPropTypes,
  provisionsCalculationsWithErrorsPropTypes,
  provisionsOtherErrorsPropTypes,
  journalsPropTypes,
  localJournalsPropTypes,
} from '../../shared/propTypes';

import {
  defaultColumnDefs,
  allProvisionsColumnDefs,
  processedSuccessfullyColumnDefs,
  trialBalancesNotReceivedColumnDefs,
  trialBalancesValidationErrorsColumnDefs,
  calculationErrorsColumnDefs,
  otherErrorsColumnDefs,
} from '../../shared/columnDefinitions/provisionQualitySingle';

import JournalsGrid from './journalsGrid.component';

const TabTypes = {
  ALL_COMPANIES: 'ALL_COMPANIES',
  PROCESSED_SUCCESSFULLY: 'PROCESSED_SUCCESSFULLY',
  TRIAL_BALANCES_NOT_RECEIVED: 'TRIAL_BALANCES_NOT_RECEIVED',
  TRIAL_BALANCES_WITH_ERRORS: 'TRIAL_BALANCES_WITH_ERRORS',
  CALCULATION_ERRORS: 'CALCULATION_ERRORS',
  OTHER_ERRORS: 'OTHER_ERRORS',
  JOURNALS: 'JOURNALS',
};

export default class ProvisionsGrid extends PureComponent {
  static propTypes = {
    provisionQualityLoading: PropTypes.bool.isRequired,
    allProvisions: allProvisionsPropTypes,
    processedSuccessfully: provisionsProcessedSuccessfullyPropTypes,
    trialBalancesNotReceived: provisionsTrialBalancesNotReceivedPropTypes,
    trialBalancesWithErrors: provisionsTrialBalancesWithErrorsPropTypes,
    calculationsWithErrors: provisionsCalculationsWithErrorsPropTypes,
    otherErrors: provisionsOtherErrorsPropTypes,
    journals: journalsPropTypes,
    localJournals: localJournalsPropTypes,
  };

  state = {
    activeTab: TabTypes.ALL_COMPANIES,
  };

  changeTab = (event, tabType) => {
    this.setState({
      activeTab: tabType,
    });
  };

  render() {
    const {
      provisionQualityLoading,
      allProvisions,
      processedSuccessfully,
      trialBalancesNotReceived,
      trialBalancesWithErrors,
      calculationsWithErrors,
      otherErrors,
      journals,
      localJournals,
    } = this.props;
    const { activeTab } = this.state;

    return (
      <div className="container-fluid page-content-container">
        <Tabs
          defaultValue={TabTypes.ALL_COMPANIES}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.ALL_COMPANIES} label="All Companies">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={allProvisionsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={allProvisions}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.PROCESSED_SUCCESSFULLY} label="Processed Successfully">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={processedSuccessfullyColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={processedSuccessfully}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.TRIAL_BALANCES_NOT_RECEIVED} label="Trial Balances Not Received">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={trialBalancesNotReceivedColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={trialBalancesNotReceived}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.TRIAL_BALANCES_WITH_ERRORS} label="Trial Balances With Errors">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={trialBalancesValidationErrorsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={trialBalancesWithErrors}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.CALCULATION_ERRORS} label="Calculation Errors">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={calculationErrorsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={calculationsWithErrors}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.OTHER_ERRORS} label="Other Errors">
            <div className="single-provisions-grids">
              <AgGrid
                columnDefs={otherErrorsColumnDefs}
                defaultColDef={defaultColumnDefs}
                rowData={otherErrors}
                isGridLoading={provisionQualityLoading}
                withSearchBar
              />
            </div>
          </Tab>

          <Tab value={TabTypes.JOURNALS} label="Journals">
            <JournalsGrid
              journals={journals}
              localJournals={localJournals}
              isGridLoading={provisionQualityLoading}
            />
          </Tab>
        </Tabs>
      </div>
    );
  }
}
